<template>
    <div>
        <Staff></Staff>
    </div>
</template>

<script>
import Staff from '../aboutNew/childPage/staff.vue';

export default {
    components: {
        Staff
    },
    data() {
        return {

        }
    }
}
</script>

<style lang='scss'>
</style>